import * as React from "react";
import { FaRegEdit, FaRegTrashAlt, FaArrowLeft } from "react-icons/fa";

import Swal from "sweetalert2";
import { RxCross2 } from "react-icons/rx";
import { useState, useEffect } from "react";
import { Navigate, useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [unitLists, setUnitLists] = useState([]);

  const [disList, setDisList] = useState([]);
  const [treatLists, setTreatLists] = useState([]);

  const [conValue, setConValue] = useState("");

  const [value, setValue] = useState("");
  const [showDisID, setShowDisID] = useState(false);
  const [name, setName] = useState("");
  const [relatedBrand, setRelatedBrand] = useState("");
  const [discountID, setDiscountID] = useState([]);

  const [description, setDescription] = useState("");
  const [faceList, setFaceList] = useState([]);
  const [bodyList, setBodyList] = useState([]);
  const [conName, setConName] = useState("");

  const [bodyInjList, setBodyInjList] = useState([]);
  const [tableDisList, setTableDisList] = useState([]);
  const [disName, setDisName] = useState("");
  const [disItemName, setDisItemName] = useState([]);

  const [cardNo, setCardNo] = useState("");
  const [disItemList, setDisItemList] = useState([]);
  const [memList, setMemList] = useState([]);
  const [disItemID, setDisItemID] = useState("");
  const [disItemDelID, setDisItemDelID] = useState("");
  const Id = useLocation().pathname.split("/")[2];

  const handleDelete = (event) => {
    console.log(event, "ID");

    setDisItemList(disItemList.filter((el) => el._id !== event));
    setDisItemDelID(disItemList.filter((el) => el._id !== event)._id);
    console.log(disItemList.filter((el) => el._id !== event)._id, "id del ");
  };

  const handleConType = (name) => {
    console.log(name, "con Name");
    setConName(name);
  };
  //Type
  const handleDisName = (event, disItemID) => {
    if (disItemID && event) {
      setDisItemID([...disItemID, event]);
      console.log([...disItemID, event], "all item id");
    }
    // setDiscountID([...discountID, event])
    // console.log([...discountID, event], 'DIDIDID')

    setDisName(disList.filter((el) => el._id == event)[0].name);
    // console.log(
    //   disList.filter(el => el._id == event),
    //   'name'
    // )
    // setTableDisList([
    //   ...tableDisList,
    //   {
    //     id: tableDisList.length + 1,
    //     name: disList.filter(el => el._id == event)[0].name,
    //     relatedDiscount: event,
    //     startDate: disList.filter(el => el._id == event)[0].startDate,
    //     endDate: disList.filter(el => el._id == event)[0].endDate,
    //     type: disList.filter(el => el._id == event)[0].type,
    //     value: disList.filter(el => el._id == event)[0].value,
    //     item_name: disList.filter(el => el._id == event)[0].relatedFOCID
    //       ? disList.filter(el => el._id == event)[0].relatedFOCID.name
    //       : ''
    //   }
    // ])
    setDisItemList([
      ...disItemList,
      ...tableDisList,
      {
        id: tableDisList.length + 1,
        name: disList.filter((el) => el._id == event)[0].name,
        relatedDiscount: event,
        startDate: disList.filter((el) => el._id == event)[0].startDate,
        endDate: disList.filter((el) => el._id == event)[0].endDate,
        type: disList.filter((el) => el._id == event)[0].type,
        value: disList.filter((el) => el._id == event)[0].value,
        item_name: disList.filter((el) => el._id == event)[0].relatedFOCID
          ? disList.filter((el) => el._id == event)[0].relatedFOCID.name
          : "",
      },
    ]);
    // console.log(proMedName, 'pro med')

    setShowDisID(true);
  };

  //Create
  const Update = () => {
    const data = {
      id: Id,
      name: name,
      relatedDiscount: disItemID,
      cardNo: cardNo,
      // type: disName,
      description: description,
    };

    if (conName == "Amount") data.conditionAmount = conValue;
    if (conName == "Purchase Freq") data.conditionPurchaseFreq = conValue;
    if (conName == "Package Qty") data.conditionPackageQty = conValue;

    alert(JSON.stringify(data));

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("member", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Income Data!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        window.location.reload();
        // props.setMemLists([...props.memLists, response.data.data])
      })

      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Error",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  useEffect(() => {
    const getTreatmentList = async () => {
      try {
        const res = await api.get("treatment-lists");

        setTreatLists(res.data.list);
        console.log(res.data.list, "dialog treat list ");
        setFaceList(res.data.list.filter((el) => el.bodyParts == "Face"));
        setBodyList(res.data.list.filter((el) => el.bodyParts == "Body"));
        setBodyInjList(
          res.data.list.filter((el) => el.bodyParts == "Body Injection"),
        );
        // console.log(
        //   res.data.list.filter(el => el.bodyParts == 'Body Injection'),
        //   'body inj list'
        // )
      } catch (err) {}
    };
    const getUnitList = async () => {
      try {
        const res = await api.get("treatments");

        setUnitLists(res.data.list);
        // console.log(res.data.list, 'unit list')
      } catch (err) {}
    };

    const getDisLists = async () => {
      try {
        const res = await api.get("discounts");
        setDisList(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    const getMember = async () => {
      try {
        const res = await api.get("member/" + Id);
        setMemList(res.data.list);
        console.log(res.data.data, "dis list");
        setDescription(res.data.data[0].description);
        setCardNo(res.data.data[0].cardNo);
        setName(res.data.data[0].name);
        if (res.data.data[0].conditionAmount) {
          setConName("Amount");
          setConValue(res.data.data[0].conditionAmount);
        } else if (res.data.data[0].conditionPurchaseFreq) {
          setConName("Purchase Freq");
          setConValue(res.data.data[0].conditionPurchaseFreq);
        } else {
          setConName("Package Qty");
          setConValue(res.data.data[0].conditionPackageQty);
        }
        if (res.data.data[0].relatedDiscount) {
          setDisItemList(res.data.data[0].relatedDiscount);
          setDisItemID(res.data.data[0].relatedDiscount.map((i) => i._id));

          setDisItemName(res.data.data[0].relatedDiscount);
          setShowDisID(true);
        }
      } catch (err) {
        alert(err.message);
      }
    };
    getMember();

    getDisLists();
    getUnitList();

    getTreatmentList();
  }, []);

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/member">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>

                    <li className="breadcrumb-item active">Member List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card px-3 py-2">
                <h3>Member Update</h3>
                <div class="form-group">
                  <label for="name">Card No</label>
                  <input
                    type="text"
                    class="form-control border border-info"
                    name="name"
                    defaultValue={cardNo}
                    onChange={(e) => setCardNo(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label for="name">Name</label>
                  <input
                    type="text"
                    class="form-control border border-info"
                    name="name"
                    placeholder="eg. mg mg"
                    defaultValue={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label for="name">Entitled Discount</label>
                  <select
                    class="custom-select border-info"
                    name="account_type_id"
                    id="cat"
                    onChange={
                      (e) => handleDisName(e.target.value, disItemID)
                      // setDisItemID(disItemID)
                    }
                  >
                    <option value={disItemID} hidden>
                      Select Discount
                    </option>
                    {disList.map((option, i) => (
                      <option value={option._id}>{option.name}</option>
                    ))}
                  </select>
                  {showDisID && (
                    <div className="table-responsive text-black" id="slimtest2">
                      <table className="table table-hover" id="filter_date">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Start Date</th>
                            <th>End Date</th>

                            <th>Name</th>
                            <th>Type</th>
                            <th>Amount</th>
                            {/* <th>Item</th> */}
                            {/* <th>Condition Type</th> */}
                            {/* <th>Condition Type</th> */}

                            {/* <th>Condition Value</th> */}
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {disItemList.map((item, i) => (
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {item.startDate
                                  ? item.startDate.split("T")[0]
                                  : ""}
                              </td>
                              <td>
                                {item.endDate ? item.endDate.split("T")[0] : ""}
                              </td>

                              <td>{item ? item.name : ""}</td>
                              <td>{item.type}</td>

                              <td>
                                {item ? item.conditionAmount : ""}
                                {item ? item.conditionPackageQty : ""}
                                {item ? item.conditionPurchaseFreq : ""}
                              </td>
                              {/* <td>
                            {item.conditionAmount ||
                              item.conditionPurchaseFreq ||
                              item.conditionPackageQty}
                          </td> */}
                              {/* <td>
                                {item.relatedDiscount
                                  ? item.relatedDiscount[i - 1].relatedFOCID
                                      .name
                                  : ''}
                              </td> */}
                              <td className="text-center">
                                <RxCross2
                                  onClick={() => handleDelete(item._id)}
                                />
                                &nbsp;
                              </td>
                            </tr>
                          ))}
                          {/* 
                          {tableDisList.map((item, i) => (
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {item.startDate
                                  ? item.startDate.split('T')[0]
                                  : ''}
                              </td>
                              <td>
                                {item.endDate ? item.endDate.split('T')[0] : ''}
                              </td>

                              <td>{item ? item.name : ''}</td>
                              <td>{item.type}</td>

                              <td>{item ? item.value : ''}</td>

                              <td>{item ? item.item_name : ''}</td>
                              <td className='text-center'>
                                <RxCross2
                                  onClick={() =>
                                    handleDelete(item.relatedDiscount)
                                  }
                                />
                                &nbsp;
                              </td>
                            </tr>
                          ))} */}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                <div class="form-group">
                  <label for="name">Membership Condition</label>
                  <select
                    name="currency"
                    id=""
                    className="form-control mt-1"
                    onchange="convert(this.value)"
                    onChange={(e) => handleConType(e.target.value)}
                  >
                    <option value={conName}>{conName}</option>

                    <option value="Amount">Amount</option>
                    <option value="Purchase Freq">Purchase Freq</option>
                    <option value="Package Qty">Package Qty</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="name">Condition Value</label>
                  <input
                    type="number"
                    class="form-control border border-info"
                    name="name"
                    defaultValue={conValue}
                    onChange={(e) => setConValue(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label for="name">Description</label>
                  <textarea
                    className="form-control"
                    id="description"
                    defaultValue={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>

                <div class="modal-footer">
                  <button
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={props.close}
                  >
                    Close
                  </button>
                  <button class="btn btn-primary" onClick={Update}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>

    </>
  );
}
